import AccountState from "./account.state";
import LoaderState from "./loader.state";
import NotificationState from "./notification";
import TransactionState from "./transaction.state";
import UserState from "./user.state";
import QuestionState from "./question";
import PlanState from "./plan";
import SettingsState from "./settings.state";
import BankAccountState from "./bankAccount.state";
import VasState from "./vas.state";
import RateState from "./rate.state";
import AppState from "./app.state";
import BusinessState from "./business.state";
import SubscriptionState from "./subscription.state";
import DisputeState from "./dispute";
import CardState from "./card.state";
import WalletState from "./wallet.state";

const states = {
    ...SettingsState,
    ...TransactionState,
    ...UserState,
    ...PlanState,
    ...LoaderState,
    ...NotificationState,
    ...AccountState,
    ...QuestionState,
    ...BankAccountState,
    ...VasState,
    ...RateState,
    ...AppState,
    ...BusinessState,
    ...SubscriptionState,
    ...DisputeState,
    ...CardState,
    ...WalletState
};

export default states;